// extracted by mini-css-extract-plugin
module.exports = {"tablaGen":"style_tablaGen__2uu3-","fila":"style_fila__3vp3N","col":"style_col__3YQxP"};